import React from 'react'
import { ISEOProps, SEO } from '../../components/Page/SEO'

const AroundSchoolsSEO = ({
  image = 'https://image.laputan.com.au/global/0905658b-81e6-4b0f-b3c1-706253a2e090.png',
  title = 'AroundSchools',
  ...props
}: ISEOProps) => <SEO {...props} title={title} image={image} />

export { AroundSchoolsSEO }
